export default __webpack_public_path__ + "static/media/at-office.0d5a43bd.svg";